<template>
  <v-container class="mt-4 ml-2" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title primary-title>
            <span class="text-subtitle-1">Sucursales</span>
            <v-spacer></v-spacer>
            <v-btn 
              class="mr-2" 
              small dark color="green"
              @click="exportExcel( sucursales  , 'sucursales')"
              tile
            >
              <v-icon small>mdi-microsoft-excel</v-icon>
            </v-btn>

            <v-btn
              color="primary"
              dark
              class="mr-2"
              @click="dialog = true"
              small
              tile
            >
              <v-icon small>mdi-plus</v-icon>
            </v-btn>

            <v-btn
              color="orange"
              dark
              class="text-capitalize"
              @click="initialize()"
              small
              tile
            >
              <v-icon small>mdi-refresh</v-icon>
            </v-btn>

          </v-card-title>

          <v-card-text>
            <v-row justify="end">
              <v-col cols="12" md="8">
                <v-text-field
                  name="name"
                  label="Buscar"
                  id="id"
                  filled
                  dense
                  single-line
                  hide-details
                  append-icon="mdi-magnify"
                  v-model="search"
                >
                </v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="headers"
                  :items="sucursales"
                  class="elevation-0"
                  :search="search"
                  :page.sync="page"
                  @page-count="pageCount = $event"
                  :mobile-breakpoint="100"
                  hide-default-footer
                  dense
                >
                  <!-- Valores que ocupan botons, chips, iconos, etc -->
                  <template v-slot:item.activo_sn="{ item }">
                    <v-chip 
                      v-if="item.activo_sn == 1"
                      small
                      color="green"
                      dark
                    >Si</v-chip>

                    <v-chip 
                      v-else
                      small
                      color="error"
                      dark
                    >No</v-chip>
                  </template>
                

                  <template v-slot:item.actions="{ item }">
                    <v-btn 
                      color="primary" 
                      x-small
                      @click="editItem(item)"
                      class="mr-2"
                    >
                      <v-icon small>mdi-magnify</v-icon>
                    </v-btn>

                    <v-btn 
                      color="error" 
                      x-small
                      @click="deleteItem(item)"
                      class="mr-2"
                    >
                      <v-icon small> mdi-delete</v-icon>
                    </v-btn>
                  </template>

                  <template v-slot:no-data>
                    <v-btn
                      color="primary"
                      @click="initialize"
                      small
                    >
                      Actualizar
                    </v-btn>
                  </template>

                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-pagination
              circle
              v-model="page"
              :length="pageCount"
              :total-visible="7"
            ></v-pagination>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <!-- Dialogo de editar o agregar-->
    <v-dialog
      v-model="dialog"
      max-width="400px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">{{ formTitle }}</span>
          <v-spacer></v-spacer>
          <span class="text-subtitle-1">
            <strong>ID: {{ editedItem.idsucursales }}</strong>
          </span>
        </v-card-title>

        <v-card-text>
          <v-text-field
            v-model="editedItem.sucursal"
            label="sucursal"
            filled
            dense
          ></v-text-field>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="red"
            dark
            dense
            rounded
            small
            @click="close"
          >
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            dark
            dense
            rounded
            small
            @click="save"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialogo para eliminar -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-text>
          <v-row justify="space-around">
            <v-col cols="6">
              <v-card class="elevation-0" height="100%" style="display: table;">
                <div class="text-subtitle-1" style="display: table-cell; vertical-align: middle;">
                  <strong>Eliminar</strong> ¿Estás seguro que deseas eliminar el sucursal?
                  <v-card-actions class="pt-6">
                    <!-- Cerrar dialogo de confirmación y abrir el dialogo de editar la clase -->
                    <v-btn color="error" text  class="mr-2" @click="closeDelete()">No, cancelar</v-btn>
                    <!-- Guardar la información  -->
                    <v-btn color="#5C5C5C"  dark class="elevation-6"  @click="deleteItemConfirm()">Si</v-btn>
                  </v-card-actions>
                </div>
              </v-card>
            </v-col>
            <v-col cols="5">
              <v-img src="@/assets/borrar.png"></v-img>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </v-container>
</template>
<script>
  import { mapGetters } from 'vuex'
  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'

  export default {
    components:{
      Alerta,
      carga,
    },

    mixins: [ validarErrores, funcionesExcel ],
    
    data: () => ({
      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      dialog: false,
      dialogDelete: false,
      
      editedIndex: -1,

      editedItem: {
        idsucursales:0,
        sucursal:'',
        idsucursales:0,
        fecha_creacion:null,
        deleted:null,
      },

      defaultItem: {
        idsucursales:0,
        sucursal:'',
        idsucursales:0,
        fecha_creacion:null,
        deleted:null,
      },

      // Filtros: 
      incio:null,
      fin:null,

      // tabla
      search:'',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      sucursales: [],
      headers: [
        { text: 'ID'            , value: 'idsucursales'       },
        { text: 'sucursal'     , value: 'sucursal'           },
        { text: 'Alta'          , value: 'fecha_creacion'      },
        { text: 'Actions'       , value: 'actions', sortable: false },
      ],
      departamentos:[],
    }),

    computed: {
      ...mapGetters('login',['getdatosUsuario']),
      formTitle () {
        return this.editedIndex === -1 ? 'Agregar sucursal' : 'Editar el sucursal'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },

    },

    async created () {
      await this.initialize()
      await this.getDepartamentos( )
    },

    methods: {
      initialize () {
        this.cargar = true
        this.sucursales = []
        return this.$http.get('sucursales.list').then(response=>{
          this.sucursales = response.body
          this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      getDepartamentos () {
        this.cargar = true
        this.departamentos = []
        return this.$http.get('departamentos.list').then(response=>{
          this.departamentos = response.body
          this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      editItem (item) {
        this.editedIndex = this.sucursales.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.sucursales.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.cargar = true
        // Lo mandapos por el EP
        this.editedItem.deleted = 1
        this.$http.put('sucursales.update/' + this.editedItem.idsucursales, this.editedItem).then(response=>{
          this.cargar = true
          this.closeDelete()
          this.initialize()
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        if(this.editedItem.sucursal == ''){
          this.validarErrorDirecto('Favor de llenar todos los campos')
        }
        this.cargar = true

        if (this.editedIndex > -1) {
          // Lo mandapos por el EP
          this.$http.put('sucursales.update/' + this.editedItem.idsucursales, this.editedItem).then(response=>{
            this.close()
            this.validarSuccess( response.body.message )
            this.initialize()
          }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })

        } else {
          // Lo mandapos por el EP
          this.$http.post('sucursales.add', this.editedItem).then(response=>{
            this.close()
            this.initialize()
            this.cargar = false
          }).catch( error =>{
            this.validarError( error )
          }).finally( () => { this.cargar = false })
        }
      },
    },
  }
</script>


